import { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; window.dispatchEvent(new Event("pwa-installable")); });
}
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

// Phone-only "Install app" button: native prompt on Android/Chrome, how-to on iPhone.
export const InstallAppButton = ({ className = "" }) => {
  const [, force] = useState(0);
  const [installed, setInstalled] = useState(standalone());
  useEffect(() => {
    const on = () => force((n) => n + 1);
    const done = () => setInstalled(true);
    window.addEventListener("pwa-installable", on);
    window.addEventListener("appinstalled", done);
    return () => { window.removeEventListener("pwa-installable", on); window.removeEventListener("appinstalled", done); };
  }, []);
  if (installed) return null;
  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const r = await deferred.userChoice;
      deferred = null;
      if (r.outcome === "accepted") setInstalled(true);
      return;
    }
    toast.info(isIos()
      ? "In Safari tap the Share button, then 'Add to Home Screen'."
      : "Open the browser menu (⋮) and tap 'Install app' or 'Add to Home screen'.", { duration: 8000 });
  };
  return (
    <button type="button" onClick={install} data-testid="install-app-btn"
      className={`lg:hidden w-full inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 px-3 py-2.5 text-sm font-semibold text-white shadow active:opacity-90 ${className}`}>
      <Smartphone className="w-4 h-4" /> Install TeamOne app
    </button>
  );
};
